/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Next_LabelInputs */

const en_timing_sync_next_label = /** @type {(inputs: Timing_Sync_Next_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const fr_timing_sync_next_label = /** @type {(inputs: Timing_Sync_Next_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivant`)
};

const de_timing_sync_next_label = /** @type {(inputs: Timing_Sync_Next_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste`)
};

const it_timing_sync_next_label = /** @type {(inputs: Timing_Sync_Next_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimo`)
};

const ru_timing_sync_next_label = /** @type {(inputs: Timing_Sync_Next_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующий`)
};

const es_timing_sync_next_label = /** @type {(inputs: Timing_Sync_Next_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo`)
};

const zh_cn2_timing_sync_next_label = /** @type {(inputs: Timing_Sync_Next_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个`)
};

const ja_timing_sync_next_label = /** @type {(inputs: Timing_Sync_Next_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次`)
};

const hi_timing_sync_next_label = /** @type {(inputs: Timing_Sync_Next_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगला`)
};

const pt_pt2_timing_sync_next_label = /** @type {(inputs: Timing_Sync_Next_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Timing_Sync_Next_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_next_label = /** @type {((inputs?: Timing_Sync_Next_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Next_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_next_label(inputs)
	if (locale === "de") return de_timing_sync_next_label(inputs)
	if (locale === "it") return it_timing_sync_next_label(inputs)
	if (locale === "ru") return ru_timing_sync_next_label(inputs)
	if (locale === "es") return es_timing_sync_next_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_next_label(inputs)
	if (locale === "ja") return ja_timing_sync_next_label(inputs)
	if (locale === "hi") return hi_timing_sync_next_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_next_label(inputs)
	return en_timing_sync_next_label(inputs)
});